/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  push_child_array_bulk,
  edit_child_array_bulk,
} from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/
import uuid from "../../App/validation/uuid";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const GENERATE_ROW_BULK = ({
  layer: { layer_id, geo_layer_list },
  auth,
  feature_key,
  parent_uuid,
  parent_uuid_temp,
  child_fields_shown = [],
  toggle_generate_row_bulk,
  push_child_array_bulk: action_push_child_array_bulk,
  edit_child_array_bulk: action_edit_child_array_bulk,
}) => {
  const [state, set_state] = useState({
    field_name: "",
    first_value: 1,
    growth: 1,
    rows_total: 3,
    skip: 0,
    body: {},
    preview_status_push: false,
    preview_status_edit: false,
    modal_warn: false,
  });

  const {
    field_name,
    first_value,
    growth,
    rows_total,
    skip,
    body,
    preview_status_push,
    preview_status_edit,
    modal_warn,
  } = state;

  const toggle_warn = () => {
    set_state((prev) => ({ ...prev, modal_warn: !prev.modal_warn }));
  };

  const on_change = (e) => {
    set_state((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const on_cancel = () => {
    set_state((prev) => ({
      ...prev,
      preview_status_push: false,
      preview_status_edit: false,
      field_name: "",
      first_value: 1,
      growth: 1,
      rows_total: 3,
      skip: 0,
      body: {},
    }));
  };

  const on_generate_push = () => {
    const uuid_field = uuid();
    const field = {
      parent_uuid,
      uuid: uuid_field,
      key: uuid_field,
      name: field_name,
      description: "",
      type: "arithmetic",

      array_templates: [],
      isHighlight: false,
      isRequired: false,
      isAllowOtherAnswer: false,
      isHide: false,
      isStyle: false,
      defaultValue: "",
      index: 0,
      min: 0,
      max: 0,
      step: 0,
      term_mode: "",
      term: [],
      digit_term: [],
      picture_url: "",
      poi_type: "",
      poi_rad: 0,
      reference_list: [],
      reference_key: "",
      formula: [],
      reference_list_2d: {},
      decimal_digits: "",
      conditional_statement_list: [],
      custom_counting_id: "",
      value: "",
      table_formula: {},

      first_value,
      growth,
      rows_total,
      skip,
    };

    let child_object_array = [];
    for (let index = 0; index < rows_total; index++) {
      const child_object = {
        child_uuid: uuid(),
        parent_uuid,
        parent_uuid_temp,
        properties: {
          [uuid_field]: Number(first_value) + index * Number(growth),
        },
      };
      child_object_array.push(child_object);
    }

    const new_body = {
      feature_key,
      geo_layer_id: layer_id,
      parent_uuid,
      parent_uuid_temp,
      field,
      child_object_array,
      field_uuid: uuid_field,
    };

    set_state((prev) => ({
      ...prev,
      body: new_body,
      preview_status_push: true,
    }));
  };

  const on_generate_edit = () => {
    const uuid_field = uuid();
    const field = {
      parent_uuid,
      uuid: uuid_field,
      key: uuid_field,
      name: field_name,
      description: "",
      type: "arithmetic",

      array_templates: [],
      isHighlight: false,
      isRequired: false,
      isAllowOtherAnswer: false,
      isHide: false,
      isStyle: false,
      defaultValue: "",
      index: 0,
      min: 0,
      max: 0,
      step: 0,
      term_mode: "",
      term: [],
      digit_term: [],
      picture_url: "",
      poi_type: "",
      poi_rad: 0,
      reference_list: [],
      reference_key: "",
      formula: [],
      reference_list_2d: {},
      decimal_digits: "",
      conditional_statement_list: [],
      custom_counting_id: "",
      value: "",
      table_formula: {},

      first_value,
      growth,
      rows_total,
      skip,
    };

    const cloned_child_fields = JSON.parse(JSON.stringify(child_fields_shown));

    for (let index = 0; index < rows_total; index++) {
      const target_index = index + Number(skip);
      if (cloned_child_fields[target_index]) {
        cloned_child_fields[target_index].properties[uuid_field] =
          Number(first_value) + index * Number(growth);
      }
    }

    const new_body = {
      feature_key,
      geo_layer_id: layer_id,
      parent_uuid,
      parent_uuid_temp,
      field,
      child_object_array: cloned_child_fields,
      field_key: field.key,
    };

    set_state((prev) => ({
      ...prev,
      body: new_body,
      preview_status_edit: true,
    }));
  };

  const on_generate = () => {
    if (!field_name) {
      set_state((prev) => ({ ...prev, modal_warn: true }));
    } else if (child_fields_shown.length === 0) {
      on_generate_push();
    } else {
      on_generate_edit();
    }
  };

  const on_save = () => {
    if (child_fields_shown.length === 0) {
      action_push_child_array_bulk(body);
    } else {
      action_edit_child_array_bulk(body);
    }
    toggle_generate_row_bulk();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //content
  let preview_content;
  if (preview_status_push) {
    const child_object_array = body?.child_object_array || [];
    const field = body?.field || {};
    preview_content = (
      <main>
        <table className="table">
          <thead>
            <tr>
              <th>No</th>
              <th>{field?.name}</th>
            </tr>
          </thead>
          <tbody>
            {child_object_array.map((item, idx) => {
              return (
                <tr key={item.child_uuid || idx}>
                  <td>{idx + 1}</td>
                  <td>{item?.properties?.[field?.uuid]}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
    );
  }

  if (preview_status_edit) {
    const child_object_array = body?.child_object_array || [];
    const field = body?.field || {};
    const layer_object = geo_layer_list.find(
      (item) => item?.geo_layer?._id === layer_id,
    )?.geo_layer;

    let fields = layer_object?.fields || [];
    fields = fields.filter((item) => item.parent_uuid === parent_uuid);

    preview_content = (
      <main>
        <table className="table">
          <thead>
            <tr>
              <th>No</th>
              {fields.map((field_item) => {
                return <th key={field_item.uuid}>{field_item.name}</th>;
              })}
              <th>{field?.name}</th>
            </tr>
          </thead>
          <tbody>
            {child_object_array.map((item, index_child) => {
              return (
                <tr key={item.child_uuid || index_child}>
                  <td>{index_child + 1}</td>
                  {fields.map((field_item) => {
                    return (
                      <td key={field_item.uuid}>
                        {
                          child_fields_shown?.[index_child]?.properties?.[
                            field_item?.key
                          ]
                        }
                      </td>
                    );
                  })}
                  <td>{item?.properties?.[field?.uuid]}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
    );
  }

  const modal_warn_content = modal_warn && (
    <Modal modalSize="small" isOpen={modal_warn} onClose={toggle_warn}>
      <div className="box-body" id="box-body">
        {dict?.["Fill in the column name first"]?.[language]}
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_warn_content}
      <h1>{dict?.["Arithmetic row parameters"]?.[language]}</h1>
      <section className="margin_bottom">
        <p>{dict?.["Column Name"]?.[language]}</p>
        <input
          name="field_name"
          value={field_name}
          onChange={on_change}
          placeholder="Nama kolom"
          type="text"
        />
      </section>
      <section className="margin_bottom">
        <p>{dict?.["First value"]?.[language]}</p>
        <input
          name="first_value"
          value={first_value}
          onChange={on_change}
          placeholder="Nilai pertama"
          type="number"
        />
      </section>
      <section className="margin_bottom">
        <p>{dict?.["Growth coefficient"]?.[language]}</p>
        <input
          name="growth"
          value={growth}
          onChange={on_change}
          placeholder="Koefision growth"
          type="number"
        />
      </section>
      <section className="margin_bottom">
        <p>{dict?.["Number of rows"]?.[language]}</p>
        <input
          name="rows_total"
          value={rows_total}
          onChange={on_change}
          placeholder={dict?.["Number of rows"]?.[language]}
          type="number"
        />
      </section>
      <section className="margin_bottom">
        <p>{dict?.["Skip value option"]?.[language]}</p>
        <input
          name="skip"
          value={skip}
          onChange={on_change}
          placeholder="Skip nilai"
          type="number"
        />
      </section>
      <button
        className={`button margin_bottom margin_right ${
          field_name ? "background_black" : "background_grey"
        }`}
        onClick={on_generate}
      >
        {dict?.["Preview"]?.[language]}
      </button>
      {(preview_status_push || preview_status_edit) && (
        <>
          <button
            className="button margin_bottom margin_right"
            onClick={on_save}
          >
            {dict?.["Save"]?.[language]}
          </button>
          <button
            className="button margin_bottom margin_right background_red"
            onClick={on_cancel}
          >
            {dict?.["Cancel"]?.[language]}
          </button>
        </>
      )}
      {preview_content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  push_child_array_bulk,
  edit_child_array_bulk,
})(GENERATE_ROW_BULK);
